export default __webpack_public_path__ + "static/media/code.8c7a4b83.svg";